/**
 * Внешние мессенджеры.
 *
 * Класс `.max-link` на элементе — открывает Макс в новой вкладке.
 * URL закодирован в base64, чтобы не спамили боты по прямой ссылке.
 */
const MAX_URL = atob(
  "aHR0cHM6Ly9tYXgucnUvdS9mOUxIb2REMGNPTEJRRzdsX0l1cFRreFFyY1Ezb3hDRUQ4WmJWVFNaR2c5Q0ZvWmIzRGdCdzRFdkpj"
);

export function initSocialLinks() {
  document.querySelectorAll(".max-link").forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      window.open(MAX_URL, "_blank", "noopener,noreferrer").focus();
    });
  });
}
